import { useEffect, useState } from 'react'

/**
 * 
 * AppStorage
 * 
 */

const AppStorage = () => {

    //服务
    const [OnReady, setOnReady] = useState(false)

    //全景图
    const [BaseUrl, setBaseUrl] = useState("")
    const [ImageUrl, setImageUrl] = useState("")

    useEffect(()=>{
      setOnReady(true)
    }, [OnReady])

    return {

      OnReady,

      ImageUrl,
      setImageUrl,

      BaseUrl,
      setBaseUrl

    }

}

export default AppStorage